import { Component } from '@angular/core';

@Component({
    selector: 'site-footer',
    imports: [],
    templateUrl: './site-footer.component.html',
    styleUrl: './site-footer.component.scss'
})
export class SiteFooterComponent {
    getCurrentYear(): string {
        const currentYear = new Date().getFullYear().toString();

        return currentYear;
    }
}